import type { LeadCardItem } from '@/data/types';
import { cardContact } from '@/lib/leadCard';

// A website form lead's card at the top of its chat (Gary, 17 Oct): the enquiry in plain
// lines, then Call, WhatsApp and Email. WhatsApp opens New chat's approved messages for this
// chat, because a business may only start a WhatsApp chat with a message Meta approved.

interface Props {
  item: LeadCardItem;
  /** Open the approved messages for this chat; left out when WhatsApp cannot be used. */
  onWhatsApp?: () => void;
}

export function LeadCard({ item, onWhatsApp }: Props) {
  const { phone, email } = cardContact(item.text);
  const [, ...all] = item.text.split('\n');
  // A form left without sending says so first, not in its last line (Gary, 19 Oct: Zandile's read as part of the chat).
  const left = all.some((l) => /left the form without pressing send/i.test(l));
  const lines = all.filter((l) => !/^Message: Left the form without pressing send/i.test(l));
  return (
    // Team only, in the notes' colours (Gary, 19 Oct): the customer never sees a lead card.
    <div className="chats-leadcard">
      <b className="chats-leadcard-title">Team only · Website form</b>
      {left && <p className="chats-leadcard-flag">Left the form without sending</p>}
      <p className="chats-leadcard-text">{lines.join('\n')}</p>
      {(phone || email || onWhatsApp) && (
        <div className="chats-leadcard-actions">
          {phone && <a className="chats-btn chats-btn--ghost" href={`tel:${phone}`}>Call</a>}
          {onWhatsApp && <button type="button" className="chats-btn chats-btn--ghost" onClick={onWhatsApp}>WhatsApp</button>}
          {email && <a className="chats-btn chats-btn--ghost" href={`mailto:${email}`}>Email</a>}
        </div>
      )}
      <span className="chats-leadcard-time">{item.at}</span>
    </div>
  );
}
